module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    style: ({
      color: _vm.getColor
    })
  }, [_vm._v("\n        (" + _vm._s(_vm.mapPercentRow('percent')) + "%, " + _vm._s(_vm.mapCountRow('count')) + ")\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08deff6e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/PercentOfTotalComponent.vue
// module id = 1229
// module chunks = 2